import { StyleSheet } from 'aphrodite';
import { white } from '../../styles/colors';
import { CssSelectors } from '../../styles/styles';

export const styleSheet = StyleSheet.create({
	container: {
		boxSizing: 'border-box',
		width: '100%',
		padding: `0 16px`,
		background: white,
		...CssSelectors.allDescendants(
			{
				minHeight: 300,
			},
			'.scroll-view-content'
		),
	},
});
